export default __webpack_public_path__ + "static/media/File No. 11.380c41e0.pdf";